/**
 * search-form-helpers.js
 * Set of helper functions for the VecDyn and VecTraits forms.
 */

/**
 * For a given column, returns the selection of operators appropriate for the data in the column.
 * @param {*} column 
 * @returns operators (set of operators for the given columm)
 */
const getOperatorOptions = (column) => {
            
    let arrColumns = ["SpeciesName", "Sites", "CollectionMethods", "Years", "Location", "Variables", "Tags"]
    let strColumns = ["DatasetID", "Provider", "Title", "OriginalID", "OriginalTraitName", "OriginalTraitDef", "Interactor1Family", "Interactor1Stage", "Interactor1Order", "Interactor1Genus", "Interactor1Species", "Interactor2Genus", "Interactor2Species", "Citation", "DOI", "SubmittedBy", "CuratedByDOI", "EmbargoReleaseDate", "ContactName"]
    let numColumns = ["Collections"]

    let operators = []

    if(!column){
        operators = [
            { value: '', text: 'Select an operator', disabled: true },
        ]
    }

    if (arrColumns.includes(column)) {
        if (column === "Years") {
            operators.push(
                { value: 'eq', text: '=' , title: 'Case sensitive. Searches for rows where the years are an exact match for the provided year.', disabled: true },
                { value: 'lt', text: '<' , title: 'Searches for rows where the years are less than the provided year.'},
                { value: 'lte', text: '<=' , title: 'Searches for rows where the years are less than or equal to the provided year.'},
                { value: 'gt', text: '>', title: 'Searches for rows where the years are greater than the provided year.'},
                { value: 'gte', text: '>=' , title: 'Searches for rows where the years are greater than or equal to the provided year.'},
            );
            
            return operators;
        }
        operators = [
            { value: '', text: 'Select an operator', disabled: true },
            { value: 'contains', text: 'contains' , title: 'Not case sensitive. Searches for rows where the requested column contains the provided string.'},
            { value: 'ncontains', text: '!contains' , title: 'Not case sensitive. Searches for rows where the requested column does not contain the provided string.'},
        ]
    } else if (strColumns.includes(column)) {
        operators = [
            { value: '', text: 'Select an operator', disabled: true },
            { value: 'eq', text: '=' , title: 'Case sensitive. Searches for rows where the requested column is an exact match for the provided string.', disabled: true },
            { value: 'neq', text: '!=' , title: 'Case sensitive. Searches for rows where the requested column is not an exact match for the provided string.'},
            { value: 'contains', text: 'contains' , title: 'Not case sensitive. Searches for rows where the requested column contains the provided string.'},
            { value: 'ncontains', text: '!contains' , title: 'Not case sensitive. Searches for rows where the requested column does not contain the provided string.'},
            { value: 'sw', text: 'Starts with', title: 'Case sensitive. Searches for rows where the requested column starts with the provided string.'},
            { value: 'nsw', text: '!Starts with', title: 'Case sensitive. Searches for rows where the requested column does not start with the provided string.'},
            { value: 'in', text: 'in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is equal to one of the strings in the provided list.'},
            { value: 'nin', text: '!in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is not equal to one of the strings in the provided list.'},
        ]
    } else if (numColumns.includes(column)) {
        operators = [
            { value: '', text: 'Select an operator', disabled: true },
            { value: 'eq', text: '=' , title: 'Case sensitive. Searches for rows where the requested column is an exact match for the provided string.', disabled: true },
            { value: 'neq', text: '!=' , title: 'Case sensitive. Searches for rows where the requested column is not an exact match for the provided string.'},
            { value: 'contains', text: 'contains' , title: 'Not case sensitive. Searches for rows where the requested column contains the provided string.'},
            { value: 'ncontains', text: '!contains' , title: 'Not case sensitive. Searches for rows where the requested column does not contain the provided string.'},
            { value: 'sw', text: 'Starts with', title: 'Case sensitive. Searches for rows where the requested column starts with the provided string.'},
            { value: 'nsw', text: '!Starts with', title: 'Case sensitive. Searches for rows where the requested column does not start with the provided string.'},
            { value: 'lt', text: '<' , title: 'Searches for rows where the requested column value is less than the provided numerical input.'},
            { value: 'lte', text: '<=' , title: 'Searches for rows where the requested column value is less than or equal to the provided numerical input.'},
            { value: 'gt', text: '>', title: 'Searches for rows where the requested column value is greater than the provided numerical input.'},
            { value: 'gte', text: '>=' , title: 'Searches for rows where the requested column value is greater than or equal to the provided numerical input.'},
            { value: 'in', text: 'in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is equal to one of the strings in the provided list.'},
            { value: 'nin', text: '!in', title: 'Case sensitive. Individual terms deliniated by a "|" character. Searches for rows where the requested column value is not equal to one of the strings in the provided list.'},
        ]
    }
    
    return operators;
}

/**
 * get the difference between the lengths of two arrays.
 * @param {*} newArr 
 * @param {*} oldArr 
 * @returns 
 */
const getArrayDiffIndex = (newArr, oldArr) => {
    if (newArr.length > oldArr.length){
        return newArr.length - 1;
    }
    for (let i = 0; i < newArr.length; i++){
        if (newArr[i] != oldArr[i]){
            return i;
        }
    }
}

/**
 * extracts a particular array from the URL query params and loads into a local array. Generally those are
 * the field, operator and term arrays.
 * @param {Object} queryObject
 * @param {string} param 
 * @returns Array arr
 */
const extractArrayFromQuery = (queryObject, param) =>{
    // flush array

    let arr = [];

    // if the given parameter is in the query object, assign the local array the param's contents
    if (param in queryObject) {
        // It appears that if there is only one value in a $route.query key, it is a string. If there are more
        // than one it is an array. Because of that, we have to check the type of the parameter before we can 
        // assign it properly.
        if ((typeof queryObject[param]) == "string") {
            arr[0] = queryObject[param];
        } else {
            arr = queryObject[param];
        }

    // else set the first element of the array to an empty string to allow the field's default text to show
    } 
    else {
        arr[0] = '';
    }
    return arr;
}

export { getOperatorOptions, getArrayDiffIndex, extractArrayFromQuery }